"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = void 0;
function getErrorMessage(e) {
    var _a, _b;
    var message = ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data.error) || ((_b = e.response) === null || _b === void 0 ? void 0 : _b.data.message) || e.message;
    if (message)
        return message;
    try {
        var data = JSON.parse(e);
        if (data.error) {
            return data.error;
        }
        else {
            return "Something went terribly wrong";
        }
    }
    catch (e) {
        return "Something went extremely wrong";
    }
}
exports.getErrorMessage = getErrorMessage;
